import { DataBean } from "../DataBean";

export class InvoiceToType extends DataBean {

    public async getInvoiceToTypeConstants(args: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getInvoiceToTypeConstants_Number", [args]);
    }

}